/**
 * Configurações de segurança e acesso do Superadministrador.
 * As credenciais são carregadas exclusivamente das variáveis de ambiente (.env),
 * garantindo que nenhum dado sensível fique exposto no código-fonte.
 */

export const getSuperAdminEmail = (): string => {
  return (
    import.meta.env.VITE_SUPERADMIN_EMAIL || "tecnologia@grupodotus.com.br"
  )
    .trim()
    .toLowerCase();
};

export const isSuperAdminEmail = (email?: string | null): boolean => {
  if (!email) return false;
  const cleanEmail = email.trim().toLowerCase();
  const configured = getSuperAdminEmail();
  if (configured && cleanEmail === configured) return true;
  if (cleanEmail === "tecnologia@grupodotus.com.br") return true;
  return false;
};
